import * as licenceActions from '../actions/userLicences';

const initialState = {
    licences: [],
    isInitialised: false
};

export default (state = initialState, action) => {
    switch (action.type) {

        case licenceActions.USER_LICENCES_RECEIVED:
            return {
                ...state,
                licences: action.licences,
                isInitialised: true
            };

        case licenceActions.USER_LICENCES_RESET:
            return {
                ...state,
                licences: [],
                isInitialised: false
            };

        default:
            return state;
    }
};